import { ArrowRight, BadgeHelp } from "lucide-react";
import { VoucherUsageBannerProps } from "@/shared/components/voucherUsageBanner/types";
import { useVoucherCategoryByEvent } from "@/shared/hooks/useVoucherCategoryByEvent";
import { P } from "@/shared/ui/typographies/paragraph";

export const VoucherUsageBanner = ({
  event,
  mascotThumbnailUrl,
}: VoucherUsageBannerProps) => {
  const category = useVoucherCategoryByEvent(event);

  const bannerTitle = category
    ? `Utilisation des bons ${category.event}`
    : "Utilisation des bons";

  return (
    <div className="rounded-lg overflow-hidden border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/30 relative">
      <div className="px-4 py-3">
        <div className="flex items-center gap-3 mb-3">
          <BadgeHelp size={20} className="text-blue-600 dark:text-blue-400" />
          <P className="text-base font-semibold text-blue-800 dark:text-blue-200">
            {bannerTitle}
          </P>
        </div>

        <div className="space-y-4 pb-6">
          <P className="text-base leading-relaxed text-blue-700 dark:text-blue-300">
            {category?.description ||
              "Les bons vous permettent de financer vos dépenses selon les conditions définies."}
          </P>

          {category?.pdf && (
            <a
              href={category.pdf}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 dark:text-blue-400 underline flex items-center gap-1 hover:text-blue-800 dark:hover:text-blue-200"
            >
              <ArrowRight size={16} className="ml-0.5" />
              Consulter les enseignes éligibles
            </a>
          )}
        </div>
      </div>

      {mascotThumbnailUrl && (
        <img
          src={mascotThumbnailUrl}
          alt="Yeati"
          className="w-40 h-40 absolute right-0 -bottom-16"
        />
      )}
    </div>
  );
};
